import {
    Container,
    Row,
    Col
} from 'reactstrap';
import styles from './styles.module.scss';
import clsx from "classnames";
import PropTypes from "prop-types";
import EditableText from "@/components/EditableText";
import SourceFlowApplicationForm from "@sourceflow-uk/sourceflowapplicationform";

export default function JobApplicationForm({
    className,
    global,
    pathPrefix,
    job_apply_heading,
    page
}) {
    return (
        <>
            <div className={`${clsx(className, styles.root)} post-application-overlays`}>
                <div className='post-application' id="apply-now">
                    <div className='inner-post-application'>
                        <EditableText
                            content={job_apply_heading}
                            path={`${pathPrefix}.apply_job.heading`}
                            global={global}
                            tag={`h3`}
                            className={`heading h1 mb-4`}
                        />
                        <SourceFlowApplicationForm onSubmitDone={() => window.location.href = successPageUrl} jobId={page.id} />
                    </div>
                </div>
            </div>
        </>
    )
}

JobApplicationForm.defaultProps = {
    pathPrefix: "",
    className: "p",

};

JobApplicationForm.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
};